import { render } from "./BlockedSenders.vue?vue&type=template&id=28a53a69&ts=true"
import script from "./BlockedSenders.vue?vue&type=script&lang=ts"
export * from "./BlockedSenders.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__